export default __webpack_public_path__ + "static/media/2-pieces-lower-mantle.de8a1265.svg";